<template>
    <div>
        <e-taglist>
            <e-tag v-for="(group, index) in visibleGroups" :key="index" type="primary">{{ group.name }}</e-tag>

            <Button
                v-if="overflowCount > 0"
                variant="text"
                size="small"
                :label="expanded ? 'Show less' : `+${overflowCount} more`"
                @click="expanded = !expanded"
            />
        </e-taglist>
    </div>
</template>

<script>
export default {
    name: 'MetaGroups',
    props: {
        groups: {
            type: Array,
            required: true,
        },

        maxVisibleTags: {
            type: Number,
            required: false,
            default: null,
        },
    },

    data: () => ({
        expanded: false,
    }),

    computed: {
        visibleGroups() {
            if (this.expanded || !this.maxVisibleTags || this.groups.length <= this.maxVisibleTags) {
                return this.groups;
            }

            return this.groups.slice(0, this.maxVisibleTags);
        },

        overflowCount() {
            if (!this.maxVisibleTags) {
                return 0;
            }

            return Math.max(0, this.groups.length - this.maxVisibleTags);
        },
    },
};
</script>
